import { TreeView } from '../components/main-filters/more-filter-popup/task-filter/task-type-tree-view/task-type-tree-view.component';

export class TaskSelectionFilters {
    LeaveType = '';
    CompanyId = 0;
    DoctorId = 0;
    From = '';
    To = '';
    Historial: boolean;
    PageIndex = 0;
    PageSize = 0;
    Prioritarias: boolean;
    Autor = '';
    TipoAutor: string;
    MedicoId: number;
    TaskType = new Array<TreeView>();
    Orden = 'Fecha';
    FPAFromDate = null;
    FPAToDate = null;
    DiasFrom?: number = null;
    DiasTo?: number = null;
    Coordinador = '';
    Gestor = '';
    ColumnsList:any;
    EmpresaSelec:boolean;
    Poblacion:string;
    Provincia:string;
}
